export default __webpack_public_path__ + "static/Brandon-Bold-700-0046bf40302439f5ff878ff873696c1c.woff2";